import { signInUser, checkTokenType, getAccessToken } from './states';

export const services = {
  signInUser,
  checkTokenType,
  getAccessToken,
};
